import React, { useEffect } from 'react';
import '../styles/about.css';




export default function About() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <main className="about">
            <header style={{ backgroundImage: `url('images/skyline2.png')` }} className='vertical-gradient texture1 header-alt' >
                <div class="glow-wrapper alt-head-txt">
                    <span class="glow-text">ABOUT</span>
                    <span class="stroke-text">ABOUT</span>
                </div>
            </header>
            <section className='about-main'>
                <div className='about-image'>
                    <img className='head-shot' src={process.env.PUBLIC_URL + "/images/headshot.png"}></img>
                </div>
                <div className='about-description'>
                    <h3>About Me</h3>
                    <p>Hey there, I’m Dawson — a passionate software developer with a background in UX design and a versatile full stack skillset. I love solving complex problems through clean code and creative design, and I’m especially drawn to frontend development where I can bring interfaces to life.

                        With experience in both software engineering and web design, I’ve built everything from interactive web apps, to full stack CMS systems, to polished static sites. While my sweet spot is frontend — React, JavaScript, HTML/CSS, and UX/UI design — I’m also comfortable working across the stack with Node.js, Python, Java, Spring Boot, and database tools like MySQL, MongoDB, and Google Cloud Platform.</p>
                </div>
            </section>


            <section id='resume'>





                <div className='education'>
                    <div className="iconplusheading">
                        <img src={process.env.PUBLIC_URL + "/images/educationicon.png"}
                            alt="graduation cap icon symbolizing education"></img>
                        <h3>Education</h3>
                    </div>

                    <div id='education-cards'>
                        <div className='education-card'>
                            <div className='college-logo-holder'>
                                <img src='images/wsu-logo.png' />
                            </div>

                            <h2>WSU</h2>
                            <h3>Bachelors in DTC</h3>
                        </div>
                        <div className='education-card'>
                            <div className='college-logo-holder'>
                                <img src='images/ucb-logo.png' />
                            </div>

                            <h2>UC Berkeley</h2>
                            <h3>Full stack web dev coding bootcamp</h3>
                        </div>

                        <div className='education-card'>
                            <div className='college-logo-holder'>
                                <img src='images/wgu.png' />
                            </div>
                            <h2>WGU</h2>
                            <h3>Bachelors in Software Engineering</h3>
                        </div>
                    </div>
                </div>

                <div className='work-experience'>
                    <div className="iconplusheading">
                        <img id='briefcase' src={process.env.PUBLIC_URL + "/images/workicon.png"}
                            alt="briefcase icon symbolizing work and work experience"></img>
                        <h3>Experience</h3>
                    </div>

                    <div id='work-experiencecards'>

                        <div className='we-card-format'>
                            <div className='we-card'>
                                <img src='images/YAAANA logo.png' />
                                <div className='we-line' />
                                <div className='we-content'>
                                    <h2>YAAANA</h2>
                                    <h3>Web Developer Intern</h3>
                                    <p>Interned as a web developer for YAAANA. I would create new web pages and edit existing content for them.</p>

                                </div>
                            </div>
                        </div>

                        <div className='we-card-format'>
                            <div className='we-card'>
                                <img src='images/peaceofheartlogo.png' />
                                <div className='we-line' />
                                <div className='we-content'>
                                    <h2>Peace of Heart Therapy</h2>
                                    <h3>Web Developer / Designer</h3>
                                    <p>Designed and developed the website, logo, and other promotional materials for Peace of Heart Therapy.</p>
                                </div>
                            </div>
                        </div>


                        <div className='we-card-format'>
                            <div className='we-card'>
                                <img src='images/scholoarship-auditions.jpg' />
                                <div className='we-line' />
                                <div className='we-content'>
                                    <h2>Scholarship Auditions</h2>
                                    <h3>React Developer</h3>
                                    <p>Designed and developed Between Bands as an intern for Scholarship Auditions. They then hired me to do another project for them Between Choirs.</p>
                                </div>
                            </div>
                        </div>


                        <div className='we-card-format'>
                            <div className='we-card'>
                                <img src='images/logo-2.png' />
                                <div className='we-line' />
                                <div className='we-content'>
                                    <h2>Alpha Builders</h2>
                                    <h3>Fullstack Developer</h3>
                                    <p>Designed and developed website for Alpha Builders as a freelancer. The full stack site features a CMS system.</p>

                                </div>
                            </div>
                        </div>





                    </div>

                </div>


            </section>


        </main>
    );
}